import { colors } from '../../themes/colors';

export const collapseLightV2Theme = {
  styledLinkColor: colors.royalBlue[1000],
};
